// extracted by mini-css-extract-plugin
export var infoItem = "_o9-2";
export var title = "_o9-0";
export var value = "_o9-1";